











import {
  defineComponent,
} from '@vue/composition-api';

import CommonFormWithDeliveryEditor from '@/components/Delivery/CommonFormWithDeliveryEditor.vue';

const CreateOrderByWeight = defineComponent({
  components: {
    CommonFormWithDeliveryEditor,
  },
});

export default CreateOrderByWeight;
